const items = [];
let i = 1;
let el = document.getElementById(`carousel-item-${i}`);
while (el) {
  items.push({ position: i - 1, el });
  i++;
  el = document.getElementById(`carousel-item-${i}`);
}

if (items.length > 0) {
  const options = {
    activeItemPosition: 0,
    interval: 6000,
  };

  const carousel = new Carousel(items, options);
  const prevButton = document.getElementById("data-carousel-prev");
  const nextButton = document.getElementById("data-carousel-next");

  if (prevButton) {
    prevButton.addEventListener("click", () => carousel.prev());
  }
  if (nextButton) {
    nextButton.addEventListener("click", () => carousel.next());
  }

  carousel.cycle();
}
